const translations = {
  en: {
    nav: "Skills",
    softskills_title: "Competencies",
    softskills: [
      "LLM Evaluation & RLHF", //[cite: 9, 10]
      "API Integration & Design", //[cite: 9, 10]
      "Web Performance Optimization", //[cite: 7, 8]
      "Component-driven UI/UX", //[cite: 7, 8]
      "System Debugging", //[cite: 9, 10]
      "Problem-solving",
      "Critical Thinking",
      "Communication",
      "Time Management",
      "Continuous Learning",
    ],
  },
  id: {
    nav: "Kemampuan",
    softskills_title: "Kompetensi",
    softskills: [
      "Evaluasi LLM & RLHF", //[cite: 9, 10]
      "Integrasi & Desain API", //[cite: 9, 10]
      "Optimasi Kinerja Web", //[cite: 8]
      "UI/UX Berbasis Komponen", //[cite: 8]
      "Debugging Sistem", //[cite: 10]
      "Problem-solving",
      "Berpikir Kritis",
      "Komunikasi",
      "Manajemen Waktu",
      "Pembelajaran Berkelanjutan",
    ],
  },
};

export default translations;